const euroFormatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
});

export function formatNetBankAmount(value: string | number): string {
  const amount = typeof value === "number" ? value : Number(value);
  return euroFormatter.format(amount);
}
